import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreAllSalesforceUsersReducers, coreAllSalesforceUsersWatchers } from './all';

export const coreSalesforceUsersReducers = combineReducers({
	all: coreAllSalesforceUsersReducers
});

export const coreSalesforceUsersWatchers = combineAllWatchers([ coreAllSalesforceUsersWatchers ]);
